import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function AboutPage() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <Container style={{ maxWidth: '800px' }} className="py-4">
        <Button
          variant="link"
          className="text-decoration-none mb-3 p-0"
          onClick={() => navigate('/')}
        >
          <i className="bi bi-arrow-left me-2"></i>Back
        </Button>

        <h1>About Plum</h1>

        <h2>Our Mission</h2>
        <p>
          Plum is an AI-powered renovation planning tool that helps homeowners and
          property investors turn their ideas into detailed, contractor-ready
          requirements documents. Through a guided conversation, Plum asks the
          right questions to capture every detail of your project &mdash; even the
          ones you haven't thought of yet.
        </p>

        <h2>Who We Are</h2>
        <p>
          Plum is operated by Plum Applications, Inc., a company building
          practical AI tools that help people get more done. The Plum renovation
          planning service is available at{' '}
          <a href="https://www.plum-app.com">www.plum-app.com</a>.
        </p>

        <h2>More From Plum Applications</h2>
        <p>
          Plum Applications, Inc. also builds a personal AI agent, available at{' '}
          <a href="https://agent-plum.com">agent-plum.com</a>. It's a personal
          assistant that helps you manage everyday tasks and get things done,
          bringing the same focus on helpful, AI-driven productivity to your
          daily life.
        </p>
        <p>
          We also build Swervie, available at{' '}
          <a href="https://swervie.xyz">swervie.xyz</a>. Swervie is a
          cross-retailer product catalog that consolidates listings from many
          stores into one clear, scored answer per product, so you can find the
          right thing to buy without comparing dozens of tabs.
        </p>

        <h2>Contact</h2>
        <p>
          If you have questions or feedback, please reach out to us at{' '}
          <a href="mailto:support@plum-app.com">support@plum-app.com</a>.
        </p>
      </Container>
    </div>
  );
}

export default AboutPage;
